import * as Yup from "yup";
import { CreateCustomDataProjectCommand } from "app/ApiClient";

export const initialValues: CreateCustomDataProjectCommand = {
  projectName: "",
  workdayId: "",
};

export const validationSchema = Yup.object<CreateCustomDataProjectCommand>({
  projectName: Yup.string().required(),
});
